export default class CancelToken {}
